// Styled confirm & alert modals (replaces native browser dialogs)
// Uses the #app-confirm-modal defined in application.html.erb.
// Vanilla: elementen via id, modal via de native Bootstrap 5-API; per aanroep
// worden de knop-handlers vervangen (onclick) en de hide-listener verhangen.

;(function () {
  var els = null;
  var resolveCallback = null;
  var hideHandler = null;

  function getEls() {
    // Turbolinks wisselt de <body>: cache alleen hergebruiken zolang de modal
    // nog aan het document hangt.
    if (els && els.modal && !els.modal.isConnected) { els = null; hideHandler = null; }
    if (!els) {
      els = {
        modal: document.getElementById('app-confirm-modal'),
        title: document.getElementById('app-confirm-title'),
        message: document.getElementById('app-confirm-message'),
        ok: document.getElementById('app-confirm-ok'),
        cancel: document.getElementById('app-confirm-cancel'),
        extra: document.getElementById('app-confirm-extra')
      };
    }
    return els;
  }

  // Standaardlabels in de taal van de pagina (data-i18n op de modal), met
  // Engels als terugval.
  function labels() {
    var e = getEls();
    var out = { title: 'Confirm', ok: 'OK', cancel: 'Cancel', notice: 'Notice' };
    if (!e.modal) return out;
    try { Object.assign(out, JSON.parse(e.modal.dataset.i18n || '{}')); } catch (err) { /* keep defaults */ }
    return out;
  }

  function bsModal(el) {
    return window.bootstrap ? window.bootstrap.Modal.getOrCreateInstance(el) : null;
  }

  function setHideHandler(modalEl, fn) {
    if (hideHandler) modalEl.removeEventListener('hide.bs.modal', hideHandler);
    hideHandler = fn;
    if (fn) modalEl.addEventListener('hide.bs.modal', fn);
  }

  // -- Public: styled confirm (returns a Promise) --
  window.appConfirm = function (message, options) {
    options = options || {};
    var e = getEls();
    if (!e.modal) return Promise.resolve(window.confirm(message));

    e.title.textContent = options.title || labels().title;
    e.message.textContent = message;
    e.ok.textContent = options.okText || labels().ok;
    e.ok.classList.remove('btn-primary', 'btn-alert');
    e.ok.classList.add(options.danger ? 'btn-alert' : 'btn-primary');
    e.cancel.textContent = options.cancelText || labels().cancel;
    // Altijd terugzetten: een eerdere appAlert() verbergt deze knop, en de
    // modal is app-breed gedeeld. Zonder deze regel toont de eerstvolgende
    // bevestiging alleen nog de OK-knop (geen "Blijven" meer).
    e.cancel.style.display = '';
    // Optional third button. Only shown when the caller asks for it; it resolves
    // the promise with the string 'extra' so existing true/false callers are
    // unaffected (they never pass extraText, so the button stays hidden).
    if (options.extraText) {
      e.extra.textContent = options.extraText;
      e.extra.classList.remove('d-none', 'btn-primary', 'btn-alert', 'btn-alt');
      e.extra.classList.add(options.extraClass || 'btn-alt');
    } else {
      e.extra.classList.add('d-none');
    }

    var modal = bsModal(e.modal);

    return new Promise(function (resolve) {
      resolveCallback = resolve;

      e.ok.onclick = function () {
        resolveCallback = null;
        if (modal) modal.hide();
        resolve(true);
      };

      e.cancel.onclick = function () {
        resolveCallback = null;
        if (modal) modal.hide();
        resolve(false);
      };

      e.extra.onclick = function () {
        resolveCallback = null;
        if (modal) modal.hide();
        resolve('extra');
      };

      setHideHandler(e.modal, function () {
        if (resolveCallback) {
          resolveCallback(false);
          resolveCallback = null;
        }
      });

      if (modal) modal.show();
    });
  };

  // -- Public: styled alert (returns a Promise) --
  window.appAlert = function (message, options) {
    options = options || {};
    var e = getEls();
    if (!e.modal) { window.alert(message); return Promise.resolve(true); }

    e.title.textContent = options.title || labels().notice;
    e.message.textContent = message;
    e.ok.textContent = labels().ok;
    e.ok.classList.remove('btn-alert');
    e.ok.classList.add('btn-primary');
    e.cancel.style.display = 'none';
    e.extra.classList.add('d-none');

    var modal = bsModal(e.modal);

    return new Promise(function (resolve) {
      e.ok.onclick = function () {
        if (modal) modal.hide();
        e.cancel.style.display = '';
        resolve(true);
      };

      setHideHandler(e.modal, function () {
        e.cancel.style.display = '';
        resolve(true);
      });

      if (modal) modal.show();
    });
  };

  // data-turbo-confirm is wired to appConfirm in entrypoints/application.js.
})();
